import * as PropTypes from 'prop-types'

const GroupShape = PropTypes.shape({
  // Data
  permissions: PropTypes.array
})

export { GroupShape }
